import React, { useState, useEffect } from "react";
import { Link, useHistory } from 'react-router-dom';
import "./HomeExploreTopicsSection.css";
import { getLanguage } from 'react-switch-lang';
import en from '../en.json';
import ma from '../ma.json';


import shareIcon from "../assets/icons/share.svg";
import prenatalImg from "../assets/home_icons/Home Page_website-20.png";
import childImg from "../assets/home_icons/Home Page_website-21.png";
import youthImg from "../assets/home_icons/Home Page_website-22.png";
import peaceImg from "../assets/home_icons/Home Page_website-23.png";
const translationData = { en: en, mr: ma };
const HomeExploreTopicsSection = () => {
  const [language, setLanguage] = useState(() => getLanguage() || 'en');
  const history = useHistory();
  const t = (key) => {
    const langKey = language === 'ma' || language === 'mr' ? 'mr' : 'en';
    return translationData[langKey]?.[key] || '';
  };
  useEffect(() => {
    const checkLang = () => {
      const current = getLanguage() || 'en';
      setLanguage(prev => prev !== current ? current : prev);
    };
    checkLang();
    const interval = setInterval(checkLang, 500);
    window.addEventListener('storage', checkLang);
    return () => { clearInterval(interval); window.removeEventListener('storage', checkLang); };
  }, []);

  const topics = [
    {
      titleKey: "explore_topic1_title",
      descKey: "explore_topic1_desc",
      border: "blue",
      image: "https://res.cloudinary.com/dtuy184dc/image/upload/v1775279701/Garbha_Sanskar_Prenatal_Education_1_vwf2af.png",
      topicId: 2
    },
    {
      titleKey: "explore_topic2_title",
      descKey: "explore_topic2_desc",
      border: "pink",
      image: "https://res.cloudinary.com/dtuy184dc/image/upload/v1775279701/Child_Development_8_to_14_years_jprffn.png",
      topicId: 4
    },
    {
      titleKey: "explore_topic3_title",
      descKey: "explore_topic3_desc",
      border: "yellow",
      image: "https://res.cloudinary.com/dtuy184dc/image/upload/v1777011140/Youth_Power_15_to_28_years_1_kkb3ar.png",
      topicId: 5
    },
    {
      titleKey: "explore_topic4_title",
      descKey: "explore_topic4_desc",
      border: "purple",
      image: "https://res.cloudinary.com/dtuy184dc/image/upload/v1775279698/Stress_Management_mh1fiq.png",
      topicId: 8
    }
  ];

  const [copiedIndex, setCopiedIndex] = useState(null);

  const handleShare = async (e, link, title, index) => {
    if (e && e.stopPropagation) e.stopPropagation();

    const origin = window && window.location && window.location.origin ? window.location.origin : '';
    const url = link && (link.startsWith('http') || link.startsWith('https')) ? link : `${origin}${link}`;

    // Try native share first
    if (navigator.share) {
      try {
        await navigator.share({ title: title || 'Share', url });
        return;
      } catch (err) {
        // user cancelled or failed - fallback to clipboard
      }
    }

    // Fallback: copy to clipboard
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(url);
      } else {
        // Older browsers
        window.prompt('Copy this link', url);
      }
      setCopiedIndex(index);
      setTimeout(() => setCopiedIndex(null), 2000);
    } catch (err) {
      // Final fallback
      try { window.prompt('Copy this link', url); } catch (e) { /* ignore */ }
    }
  };

  const renderTitle = (title, border) => {

    const words = title.split(" ");
    const firstLine = words.slice(0, 3).join(" ");
    const secondLine = words.slice(3).join(" ");

    return (
      <div className="hm-explore-title-wrapper">
        <div className="hm-explore-title-line">
          <span
            className={`hm-explore-inline-color hm-explore-bg-${border}`}
          ></span>
          {firstLine}
        </div>
        {secondLine && (
          <div className="hm-explore-title-line">
            {secondLine}
          </div>
        )}
      </div>
    );
  };

  return (
    <section className="hm-explore-section">
      <div className="hm-explore-container">

        <p className="hm-explore-subtitle">{t('explore_our_courses')}</p>

        <h2 className="hm-explore-title">{t('explore_title')}</h2>

        <p className="hm-explore-description">
          {t('explore_desc')}
        </p>

        <div className="hm-explore-grid">
          {topics.map((item, index) => {
            const topicTitle = t(item.titleKey);
            const topicPath = `/topics/${encodeURIComponent(topicTitle)}/${item.topicId}`;

            return (
              <div
                key={index}
                className={`hm-explore-card hm-explore-border-${item.border}`}
                onClick={() => history.push(topicPath)}
                style={{ cursor: 'pointer' }}
              >
                <button
                  className="hm-explore-share"
                  onClick={(e) => handleShare(e, topicPath, topicTitle, index)}
                  aria-label={`Share ${topicTitle}`}
                  title={`Share ${topicTitle}`}
                >
                  <img src={shareIcon} alt="share" />
                  {copiedIndex === index && (
                    <span className="hm-explore-share-copied" aria-hidden>
                      Copied!
                    </span>
                  )}
                </button>

                {renderTitle(topicTitle, item.border)}

                <p className="hm-explore-card-desc">
                  {t(item.descKey)}
                </p>

                {/* ARROW LINK - navigate to internal topic route */}
                <Link to={topicPath} className="hm-explore-arrow" onClick={e => e.stopPropagation()}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M5 12h14M13 5l7 7-7 7"
                      stroke="#9d0b0e"
                      strokeWidth="2.2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </Link>

                <div className="hm-explore-bg">
                  <img src={item.image} alt="" />
                </div>
              </div>
            );
          })}
        </div>

        <div className="hm-explore-btn-wrapper">
          <Link to="/booknow/All/0?eventType=All" className="hm-explore-btn">
            {t('explore_view_all')}
            <i className="fas fa-chevron-right topic-arrow"></i>
          </Link>
        </div>

      </div>
    </section>
  );
};

export default HomeExploreTopicsSection;